module.exports = __webpack_public_path__ + "media/reskin-images/icon--lock-sm-541b58e1.svg";